import Field from '@/lib/models/field';
import Validation from '@/lib/models/validation';
import defineComponentModel from '@/lib/helpers/define-component-model';

const genCreateValidationModel = (attachField) => {
  const extractValueFn = values => values[attachField.name];

  return (item) => {
    const {
      condition,
      errorMessage,
      name,
    } = item;

    return new Validation({
      condition,
      errorMessage,
      name,
      attachField,
      extractValueFn,
    });
  };
};

const createValidationsAndAddTo = (field, validationsArray) => validationsArray
  .map(genCreateValidationModel(field));


const component = defineComponentModel(Field, {
  props: {
    name: {
      type: String,
      required: true,
    },

    ui: {
      type: Object,
      required: true,
    },

    validations: {
      type: Array,
      default: () => [],
    },

    defaultValue: {
      default: undefined,
    },

    optional: {
      type: Boolean,
      default: false,
    },

    readOnly: {
      type: Boolean,
      default: false,
    },

    presence: {
      type: Boolean,
      default: true,
    },

    blocker: {
      type: Boolean,
      default: false,
    },

    customNotEmptyErrorMessage: {
      type: String,
      default: null,
    },
  },

  created() {
    createValidationsAndAddTo(
      this.model,
      this.validations,
    );
  },

  customDataForModel() {
    return {
      defaultValue: this.defaultValue,
      optional: this.optional,
      readOnly: this.readOnly,
      presence: this.presence,
      blocker: this.blocker,
      customNotEmptyErrorMessage: this.customNotEmptyErrorMessage,
    };
  },

  render() {
    return null;
  },
});

export default component;
